/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthVerifyEmailRequestBodyAllOf } from './AuthVerifyEmailRequestBodyAllOf';
import {
    AuthVerifyEmailRequestBodyAllOfFromJSON,
    AuthVerifyEmailRequestBodyAllOfFromJSONTyped,
    AuthVerifyEmailRequestBodyAllOfToJSON,
} from './AuthVerifyEmailRequestBodyAllOf';

/**
 * 
 * @export
 * @interface AuthVerifyEmailRequestBody
 */
export interface AuthVerifyEmailRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AuthVerifyEmailRequestBody
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthVerifyEmailRequestBody
     */
    verifyCode?: string;
}

/**
 * Check if a given object implements the AuthVerifyEmailRequestBody interface.
 */
export function instanceOfAuthVerifyEmailRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthVerifyEmailRequestBodyFromJSON(json: any): AuthVerifyEmailRequestBody {
    return AuthVerifyEmailRequestBodyFromJSONTyped(json, false);
}

export function AuthVerifyEmailRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthVerifyEmailRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'verifyCode': !exists(json, 'verifyCode') ? undefined : json['verifyCode'],
    };
}

export function AuthVerifyEmailRequestBodyToJSON(value?: AuthVerifyEmailRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'verifyCode': value.verifyCode,
    };
}

